var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "portlet-body form" },
    [
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading !== 0,
              expression: "loading !== 0"
            }
          ],
          staticClass: "row"
        },
        [
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "span",
              [
                _c("div", { staticClass: "progress" }, [
                  _c(
                    "div",
                    {
                      staticClass: "progress-bar",
                      style: { width: _vm.currentProgress + "%" },
                      attrs: {
                        "aria-valuemax": _vm.progress,
                        "aria-valuenow": _vm.loading,
                        "aria-valuemin": "0",
                        role: "progressbar"
                      }
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.currentProgress) + "% Complete")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")
                ]),
                _vm._v(" "),
                _c("ring-loader")
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.sortedMeals, function(mealData, mealDate, index) {
        return [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading === 0,
                  expression: "loading === 0"
                }
              ],
              key: index
            },
            [
              _c("div", { staticClass: "row show-block-button" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-md-6",
                    staticStyle: { "padding-left": "0" }
                  },
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(mealDate) +
                          " " +
                          _vm._s(_vm.getDayNameFromDate(mealDate))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-md-6",
                    staticStyle: { "padding-right": "0" }
                  },
                  [
                    _vm.isGranted
                      ? _c("div", { staticClass: "btn-set pull-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn green",
                              on: {
                                click: function($event) {
                                  return _vm.editMenu(mealDate)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.trans("menu_planner_select.edit")
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row", staticStyle: { "margin-top": "20px" } },
                [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-bordered",
                        attrs: { id: "meal-menu-planner-table-show" }
                      },
                      [
                        _c(
                          "tbody",
                          [
                            _c("tr", [
                              _c("td", { staticClass: "menu-header" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.trans("menu_planner.final_meal"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "menu-header" }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.trans("meal.entity.rate")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "menu-header" }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.trans("badge.badge")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "menu-header" }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.trans("meal.entity.tags")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "menu-header" }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.trans("meal.entity.sizes")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "menu-header" }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.trans("meal.entity.costs")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "menu-header" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.trans("meal.entity.prices"))
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(mealData, function(selectType, position) {
                              return [
                                _c("tr", { key: position }, [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "menu-header-select-type",
                                      attrs: { colspan: "6" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(selectType.selectType.value) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(selectType.meals, function(
                                  exMeal,
                                  exMealIndex
                                ) {
                                  return _c(
                                    "tr",
                                    {
                                      key:
                                        _vm.date +
                                        "-" +
                                        position +
                                        "-" +
                                        exMealIndex
                                    },
                                    [
                                      _c("td", {
                                        domProps: {
                                          textContent: _vm._s(exMeal.meal.name)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("td", {
                                        domProps: {
                                          textContent: _vm._s(
                                            Math.round(exMeal.meal.rate * 100) /
                                              100
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm._l(
                                            exMeal.meal.mealBadges,
                                            function(mealBadge) {
                                              return [
                                                mealBadge.validFrom <=
                                                  _vm.date &&
                                                mealBadge.validTo >= _vm.date
                                                  ? _c(
                                                      "div",
                                                      { key: mealBadge.id },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.showMealBadge(
                                                                  mealBadge
                                                                    .badge.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-link"
                                                            }),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  mealBadge
                                                                    .badge.name
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm.mealTags[exMeal.meal.id] === false
                                            ? _c("span", {
                                                staticClass:
                                                  "glyphicon glyphicon-refresh glyphicon-refresh-animate"
                                              })
                                            : _vm._l(
                                                _vm.mealTags[exMeal.meal.id] ||
                                                  [],
                                                function(tag, tagIndex) {
                                                  return _c(
                                                    "span",
                                                    { key: tagIndex },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(tag.value) +
                                                          " "
                                                      ),
                                                      _c("br")
                                                    ]
                                                  )
                                                }
                                              )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm._l(exMeal.meal.servings, function(
                                            serving,
                                            servingIndex
                                          ) {
                                            return [
                                              _c("span", {
                                                key: "span-" + servingIndex,
                                                domProps: {
                                                  textContent: _vm._s(
                                                    serving.size
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("br", {
                                                key: "br-" + servingIndex
                                              })
                                            ]
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm._l(exMeal.meal.servings, function(
                                            serving,
                                            servingIndex
                                          ) {
                                            return [
                                              _c("span", {
                                                key: "span-" + servingIndex,
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.dcNumberFormat(
                                                      serving.productionCost
                                                    )
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("br", {
                                                key: "br-" + servingIndex
                                              })
                                            ]
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _vm._l(exMeal.meal.servings, function(
                                            serving,
                                            servingIndex
                                          ) {
                                            return [
                                              _c("span", {
                                                key: "span-" + servingIndex,
                                                style:
                                                  serving.suggestedLowestPrice ===
                                                  null
                                                    ? "color: red"
                                                    : "",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    serving.suggestedLowestPrice ===
                                                      null
                                                      ? "Brak ceny"
                                                      : _vm.dcNumberFormat(
                                                          serving.suggestedLowestPrice
                                                        )
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("br", {
                                                key: "br-" + servingIndex
                                              })
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-380af37d", { render: render, staticRenderFns: staticRenderFns })
  }
}